import React from 'react'

class Loading extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      pastDelay: false
    }
  }

  componentDidMount = () => {
    if (this.props.delay === 0) {
      this.setState({ pastDelay: true })
    } else {
      window.setTimeout(
        () => this.setState({ pastDelay: true }),
        this.props.delay
      )
    }
  }

  render = () => {
    if (this.state.pastDelay) {
      return <div id='loading' />
    } else {
      return null
    }
  }
}

export default Loading



// WEBPACK FOOTER //
// ./src/loading.js